export const USER_DATA_CONSTANT= {
    ADD_COMPARE:'ADD_COMPARE',
    REMOVE_COMPARE:'REMOVE_COMPARE',
    CLEAR_COMPARE:'CLEAR_COMPARE',
    ADD_COMPARE_PARAMETER: 'ADD_COMPARE_PARAMETER',
    ADD_CART_COUNT: 'ADD_CART_COUNT',
    MINUS_CART_COUNT: 'MINUS_CART_COUNT',
    CLEAR_CART_COUNT: 'CLEAR_CART_COUNT',
    ADD_DATA_CACHE:'ADD_DATA_CACHE'
}